import { render, staticRenderFns } from "./PageParentalConsent.vue?vue&type=template&id=e7c08dea&scoped=true&"
import script from "./PageParentalConsent.vue?vue&type=script&lang=ts&"
export * from "./PageParentalConsent.vue?vue&type=script&lang=ts&"
import style0 from "./PageParentalConsent.vue?vue&type=style&index=0&id=e7c08dea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c08dea",
  null
  
)

export default component.exports